export default __webpack_public_path__ + "static/media/Dune-hd-4.9b7a9a1e.jpg";